/**
 * Pulls fof/upload's inline image previews (`<figure class="FoFUpload--Upl-Image-Preview-Figure">
 * <a class="FoFUpload--Upl-Image-Preview-Link"><img class="FoFUpload--Upl-Image-Preview">...
 * <figcaption>`, the figure/figcaption added by ImageCaptionFix - see
 * migration/ImageCaptionFix.php) out of a post's already-rendered
 * contentHtml, so they can be shown as a gallery instead of buried inline in
 * the text (see DescriptionPage.js). Returns both the extracted photos and
 * the remaining HTML with those images (and any wrapping paragraph left
 * empty by their removal) stripped out, so nothing shows twice.
 */
export default function extractPostImages(html) {
  const container = document.createElement('div');
  container.innerHTML = html;
  const images = Array.from(container.querySelectorAll('img.FoFUpload--Upl-Image-Preview')).map((el, index) => {
    const img = el;
    const link = img.closest('a');
    const url = link ? link.href : img.src;
    const baseName = img.getAttribute('alt') || img.getAttribute('title') || '';
    const figure = img.closest('figure');
    const caption = figure?.querySelector('figcaption')?.textContent || null;

    // The whole <figure> (caption included) when present, so the caption
    // doesn't get left behind as an orphaned element once the photo
    // itself is pulled out into the gallery - falls back to the bare
    // <a>/<img> the same way this already did before figures existed.
    const wrapper = figure || link || img;
    const parent = wrapper.parentElement;
    wrapper.remove();
    if (parent && parent.tagName === 'P' && !parent.textContent?.trim() && !parent.querySelector('img')) {
      parent.remove();
    }
    return {
      id: img.getAttribute('data-id') || String(index),
      url,
      thumbnailUrl: img.src,
      baseName,
      caption
    };
  });
  return {
    images,
    bodyHtml: container.innerHTML
  };
}
flarum.reg.add('champis-species', 'forum/utils/extractPostImages', extractPostImages);